import { uploadPatientFaxAttachment } from '@lotushealth/lotushealth_js_sdk/endpoints';

import { createLotusRequestConfig } from '@/shared/api/lotus';

import type { DocumentDraftAttachment } from '../model/documentDraftTypes';

export async function uploadDocumentAttachment(
  patientId: string,
  file: File,
  signal?: AbortSignal
): Promise<DocumentDraftAttachment> {
  if (!file.type.startsWith('image/') && file.type !== 'application/pdf') {
    throw new Error('Only PDF and image attachments are supported.');
  }

  const config = await createLotusRequestConfig({ signal });
  const response = await uploadPatientFaxAttachment(patientId, { file }, config);

  return {
    attachmentId: String(response.data.attachment_id),
    filename: file.name,
    mimeType: file.type,
  };
}
